import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import './CitationsComponent.scss';
import { useAssistantAbly } from "../../contexts/AIAssistantAblyContext";
import { appendHandoffParam, openAssistantLink } from "../../utils/assistantHandoff";

const CitationsComponent = ({ citations }) => {
    const { conversationId } = useAssistantAbly();

    return (
        <div className="citations-component">
            {citations.map((citation, index) => (
                <div key={index} className="citation-item">
                    <div className="citation-icon-container">
                        <img src={citation.logo} alt="logo" className="citation-icon" />
                    </div>
                    <div className="citation-content">
                        <h4 className="citation-heading">{citation.title || citation.tile}</h4>
                        <p className="citation-data">{citation.date}</p>
                    </div>
                    <div className="citation-action">
                        <a
                            href={appendHandoffParam(citation.link, conversationId)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(event) =>
                                openAssistantLink(citation.link, conversationId, { event })
                            }
                        >
                            <FiExternalLink />
                        </a>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CitationsComponent;
